var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg122(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C11.1778 40 4 32.8222 4 24C4 15.1778 11.1778 8 20 8C22.379 8 24.667 8.5078 26.8008 9.5098C27.7998 9.9806 28.2304 11.17 27.7608 12.17C27.29 13.172 26.0996 13.5978 25.0996 13.131C23.503 12.3808 21.7872 12 20 12C13.3828 12 8 17.3828 8 24C8 30.6172 13.3828 36 20 36C21.415 36 22.7988 35.7578 24.1142 35.2812C25.1552 34.9022 26.3008 35.4394 26.6768 36.4766C27.0538 37.5156 26.5176 38.6622 25.4796 39.0392C23.7256 39.6778 21.8818 40 20 40Z",
    fill: "#DB2A12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 26H30C28.8956 26 28 25.1054 28 24C28 22.8946 28.8956 22 30 22H38C39.1044 22 40 22.8946 40 24C40 25.1054 39.1044 26 38 26Z",
    fill: "#DB2A12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 18H28C26.8956 18 26 17.1054 26 16C26 14.8946 26.8956 14 28 14H34C35.1044 14 36 14.8946 36 16C36 17.1054 35.1044 18 34 18Z",
    fill: "#DB2A12"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42 34H28C26.8956 34 26 33.1054 26 32C26 30.8946 26.8956 30 28 30H42C43.1044 30 44 30.8946 44 32C44 33.1054 43.1044 34 42 34Z",
    fill: "#DB2A12"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0017 28C15.2673 28 14.5613 27.5958 14.2107 26.8946C13.7165 25.9064 14.1169 24.7052 15.1053 24.211L17.9997 22.7636V20C17.9997 18.8946 18.8953 18 19.9997 18C21.1041 18 21.9997 18.8946 21.9997 20V24C21.9997 24.7578 21.5719 25.4492 20.8943 25.789L16.8943 27.789C16.6071 27.9316 16.3015 28 16.0017 28Z",
    fill: "#DB2A12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg122);
export default __webpack_public_path__ + "static/media/svg122.aa4118de5bea9823b9bd200e4153a903.svg";
export { ForwardRef as ReactComponent };